import script from "./HomeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeButton.vue?vue&type=script&setup=true&lang=js"

import "./HomeButton.vue?vue&type=style&index=0&id=02adff9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02adff9d"]])

export default __exports__